import {Directive, EmbeddedViewRef, inject, Input, TemplateRef, ViewContainerRef} from '@angular/core';

/**
 * Renders its template once and keeps it: while `appDetachWhile` is true
 * the view is left out of change detection, and it is checked again from
 * the moment the input turns false. Unlike `@if`, the view's DOM, form
 * state and child components survive the round trip.
 *
 * Nothing inside a detached view updates, so hide it from an element
 * outside the template.
 */
@Directive({
  selector: '[appDetachWhile]',
  standalone: false,
})
export class DetachWhileDirective {
  private readonly viewContainer: ViewContainerRef = inject(ViewContainerRef);
  private readonly template: TemplateRef<unknown> = inject(TemplateRef);
  private view?: EmbeddedViewRef<unknown>;

  @Input({required: true}) set appDetachWhile(detached: boolean) {
    this.view ??= this.viewContainer.createEmbeddedView(this.template);
    if (detached) {
      this.view.detach();
    } else {
      this.view.reattach();
    }
  }
}
